import { createContext } from "react";

/** "ko" | "en" — shared across all PC components */
export const LangContext = createContext("ko");
